import { useState } from "react";
import { toWords } from "number-to-words";

import CustomerForm from "./CustomerForm";
import ProductForm from "./ProductForm";
import InvoicePreview from "./InvoicePreview";

import { addInvoice } from "../api/invoiceapi";

function CreateInvoice({ setPage }) {

  // INVOICE TYPE
  const [invoiceType, setInvoiceType] =
    useState("Tax Invoice");

  // CUSTOMER
  const [customer, setCustomer] =
    useState("");

  const [phone, setPhone] =
    useState("");

  const [address, setAddress] =
    useState("");

  const [gstin, setGstin] =
    useState("");

  const [state, setState] =
    useState("");

  const [city, setCity] =
    useState("");

  // PRODUCT
  const [product, setProduct] =
    useState("");

  const [price, setPrice] =
    useState(0);

  const [qty, setQty] =
    useState(1);

  // INVOICE NUMBER
  const [invoiceNo, setInvoiceNo] =
    useState(
     
    );

  // ITEMS
  const [items, setItems] =
    useState([]);

  // PAYMENT
  const [receivedAmount, setReceivedAmount] =
    useState(0);

  // ADD ITEM
  const addItem = () => {

    if (!product || price <= 0 || qty <= 0)
      return;

    const itemTotal =
      Number(price) * Number(qty);

    const newItem = {

      product,

      price: Number(price),

      qty: Number(qty),

      gst:
        invoiceType === "Tax Invoice" ||
        invoiceType === "Proforma Invoice"
          ? itemTotal * 0.18
          : 0,

      total: itemTotal

    };

    setItems([
      ...items,
      newItem
    ]);

    setProduct("");
    setPrice(0);
    setQty(1);
  };

  // DELETE ITEM
  const deleteItem = (index) => {

    const updatedItems =
      items.filter(
        (_, i) => i !== index
      );

    setItems(updatedItems);
  };

  // CALCULATIONS
  const subTotal = items.reduce(
    (sum, item) =>
      sum + item.total,
    0
  );

  const gst =
    invoiceType === "Tax Invoice" ||
    invoiceType === "Proforma Invoice"
      ? subTotal * 0.18
      : 0;

  const grandTotal =
    subTotal + gst;

  // SAVE
  const saveInvoice = async () => {

    const data = {

      invoiceType,

      customer,

      phone,

      address,

      gstin,

      items,

      subTotal,

      gst,

      grandTotal,

      receivedAmount

    };

    try {

      const res =
        await addInvoice(data);

      console.log(res.data);

      alert(
        "Invoice Saved Successfully"
      );

    } catch (error) {

      console.log(error);

    }
  };

  // PRINT
  const printInvoice = () => {
    window.print();
  };

  // WORDS
  const amountInWords =
    toWords(grandTotal || 0);

  return (

    <main className="main">

      {/* LEFT */}
      <section className="left">

        <div className="card">

          <h3>Invoice Type</h3>

          <select
            value={invoiceType}
            onChange={(e) =>
              setInvoiceType(
                e.target.value
              )
            }
          >

            <option value="Tax Invoice">
              Tax Invoice (GST)
            </option>

            <option value="Bill of Supply">
              Without GST
            </option>

            <option value="Proforma Invoice">
              Proforma Invoice
            </option>

          </select>
  
    
      <input
        placeholder="Invoice Number"
        value={invoiceNo}
        onChange={(e) => setInvoiceNo(e.target.value)}
      />
        </div>

        {/* CUSTOMER */}
        <CustomerForm

          customer={customer}
          setCustomer={setCustomer}

          phone={phone}
          setPhone={setPhone}

          address={address}
          setAddress={setAddress}

          gstin={gstin}
          setGstin={setGstin}

          state={state}
          setState={setState}

          city={city}
          setCity={setCity}

        />

        {/* PRODUCT */}
        <ProductForm

          product={product}
          setProduct={setProduct}

          price={price}
          setPrice={setPrice}

          qty={qty}
          setQty={setQty}

          addItem={addItem}

          receivedAmount={receivedAmount}
          setReceivedAmount={
            setReceivedAmount
          }

        />

      </section>

      <section className="right">

      <button
        onClick={() => setPage("dashboard")}
        className="btn no-print"
      >
        Dashboard
      </button>

      <button
        onClick={saveInvoice}
        className="btn no-print"
      >
        Save Invoice
      </button>

      <button
        onClick={printInvoice}
        className="btn no-print"
      >
        Print Invoice
      </button>

      {/* PREVIEW */}
      <InvoicePreview
        invoiceType={invoiceType}
        customer={customer}
        phone={phone}
        address={address}
        gstin={gstin}
        items={items}
        subTotal={subTotal}
        gst={gst}
        grandTotal={grandTotal}
        deleteItem={deleteItem}
        receivedAmount={receivedAmount}
        setReceivedAmount={setReceivedAmount}
        amountInWords={amountInWords}
        invoiceNo={invoiceNo}
        state={state}
        city={city}
      />

    </section>
     

    </main>

  );
}

export default CreateInvoice;